import { CheckCircle2, Lightbulb, ArrowRight } from "lucide-react";

const ToolContentSection = ({ toolKey, content }) => {
  if (!content) return null;

  return (
    <section className="mt-16 space-y-12 text-muted-foreground">
      {/* Introduction */}
      <div>
        <p className="text-lg leading-relaxed">{content.intro}</p>
      </div>

      {/* How To Section */}
      {content.howTo && (
        <div className="bg-secondary/50 p-6 md:p-8 border border-border">
          <h2 className="text-2xl font-semibold text-foreground mb-6 font-['Outfit']">
            {content.howTo.title}
          </h2>
          <ol className="space-y-4">
            {content.howTo.steps.map((step, index) => (
              <li key={index} className="flex gap-4">
                <span className="flex-shrink-0 w-8 h-8 bg-[#FF3B30] text-white flex items-center justify-center text-sm font-semibold">
                  {index + 1}
                </span>
                <span className="pt-1">{step}</span>
              </li>
            ))}
          </ol>
        </div>
      )}

      {/* Benefits Section */}
      {content.benefits && (
        <div>
          <h2 className="text-2xl font-semibold text-foreground mb-6 font-['Outfit']">
            Why Use This Tool?
          </h2>
          <div className="grid md:grid-cols-2 gap-6">
            {content.benefits.map((benefit, index) => (
              <div 
                key={index} 
                className="border border-border p-5 hover:border-black/30 transition-colors"
              >
                <div className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-[#FF3B30] flex-shrink-0 mt-0.5" />
                  <div>
                    <h3 className="font-semibold text-foreground mb-1">{benefit.title}</h3>
                    <p className="text-sm">{benefit.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Tips Section */}
      {content.tips && (
        <div className="bg-amber-50 border border-amber-200 p-6 md:p-8">
          <div className="flex items-center gap-2 mb-4">
            <Lightbulb className="w-5 h-5 text-amber-600" />
            <h2 className="text-xl font-semibold text-foreground font-['Outfit']">
              Pro Tips
            </h2>
          </div>
          <ul className="space-y-3">
            {content.tips.map((tip, index) => (
              <li key={index} className="flex gap-3 text-amber-900">
                <ArrowRight className="w-4 h-4 flex-shrink-0 mt-1 text-amber-600" />
                <span>{tip}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Use Cases */}
      {content.useCases && (
        <div className="border-l-4 border-[#FF3B30] pl-6">
          <h2 className="text-xl font-semibold text-foreground mb-3 font-['Outfit']">
            Who Uses This Tool?
          </h2>
          <p className="leading-relaxed">{content.useCases}</p>
        </div>
      )}
    </section>
  );
};

export default ToolContentSection;
